module.exports = __webpack_public_path__ + "static/media/change-technology.fd0a5632.webp";